import React, { useState, useEffect, useRef } from 'react';
import { theme } from '../../config/theme';

const styles = {
    wrapper: { position: 'relative' },
    toggle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '44px',
        height: '44px',
        border: `1px solid rgba(246, 247, 246, 0.35)`,
        borderRadius: theme.borderRadius,
        background: 'transparent',
        color: theme.colors.textPrimary,
        cursor: 'pointer',
    },
    // Abierto, el botón (ahora "cerrar") queda por encima del fondo oscuro.
    toggleOpen: {
        position: 'relative',
        zIndex: 1550,
    },
    backdrop: {
        position: 'fixed',
        inset: 0,
        zIndex: 1400,
        backgroundColor: 'rgba(13, 26, 41, 0.45)',
    },
    panel: {
        position: 'fixed',
        top: 'calc(env(safe-area-inset-top) + 4.25rem)',
        left: '0.75rem',
        right: '0.75rem',
        zIndex: 1500,
        maxHeight: 'calc(100vh - env(safe-area-inset-top) - 5.5rem)',
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
        gap: '0.6rem',
        padding: '1rem',
        backgroundColor: theme.colors.primary,
        border: '1px solid rgba(246, 247, 246, 0.15)',
        borderRadius: '10px',
        boxShadow: '0 16px 40px rgba(13, 26, 41, 0.45)',
    },
};

const MenuIcon = ({ open }) => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        strokeWidth="2" strokeLinecap="round" aria-hidden="true">
        {open ? (
            <>
                <path d="M6 6l12 12" />
                <path d="M18 6L6 18" />
            </>
        ) : (
            <>
                <path d="M4 7h16" />
                <path d="M4 12h16" />
                <path d="M4 17h16" />
            </>
        )}
    </svg>
);

/**
 * Menú desplegable del encabezado en celulares: agrupa los datos del usuario y
 * las acciones que en escritorio se muestran en fila, para que el encabezado no
 * ocupe media pantalla. Cualquier click dentro del panel lo cierra.
 */
const MobileHeaderMenu = ({ children, label = 'Menú' }) => {
    const [open, setOpen] = useState(false);
    const toggleRef = useRef(null);

    useEffect(() => {
        if (!open) return undefined;
        const handleKey = (event) => {
            if (event.key === 'Escape') {
                setOpen(false);
                toggleRef.current?.focus();
            }
        };
        document.addEventListener('keydown', handleKey);
        return () => document.removeEventListener('keydown', handleKey);
    }, [open]);

    return (
        <div style={styles.wrapper}>
            <button
                ref={toggleRef}
                type="button"
                style={open ? { ...styles.toggle, ...styles.toggleOpen } : styles.toggle}
                onClick={() => setOpen(prev => !prev)}
                aria-expanded={open}
                aria-label={open ? 'Cerrar menú' : label}
            >
                <MenuIcon open={open} />
            </button>
            {open && (
                <>
                    <div style={styles.backdrop} onClick={() => setOpen(false)} aria-hidden="true" />
                    <div style={styles.panel} role="menu" onClick={() => setOpen(false)}>
                        {children}
                    </div>
                </>
            )}
        </div>
    );
};

export default MobileHeaderMenu;
